// extracted by mini-css-extract-plugin
export default {"content":"DvnepCzX03ZsQ1g7SqbS"};